import { render, staticRenderFns } from "./ResourceAvailabilityCard.vue?vue&type=template&id=b8d23596&"
import script from "./ResourceAvailabilityCard.vue?vue&type=script&lang=js&"
export * from "./ResourceAvailabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAvailabilityCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports